import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { Environment } from '../../classes/environment';
import { DataInput } from '@trivelope/triv-ui-tools-lib';
import { MyReCaptchaService } from 'src/app/services/my-recaptcha.service';
import {PasswordReset} from '../../classes/passwordReset';
import { SafeUrl } from '@angular/platform-browser';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  recaptchaKey = this.environment.recaptchaKey;
  recaptchaCtrl = new FormControl('', [Validators.required]);
  passwordReset: PasswordReset = new PasswordReset();
  userEmailId = new DataInput();
  isEmail: boolean = false;

  passwordForgetForm = new FormGroup({
    emailId: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')
    ])
  });

	logoSrc: SafeUrl = "";


	constructor(
		private authenicationService: AuthenticationService,
		@Inject('environment') private environment: Environment,
		private customerService: CustomerService,
    private recaptchaService: MyReCaptchaService
	) {
		this.userEmailId.label = "Ihre E-Mail Adresse";
		this.userEmailId.id = "emailId";
		this.userEmailId.type = "text";
		this.userEmailId.autocomplete = "emailId";
		this.userEmailId.errorMsg = 'Es ist eine gültige E-Mail erforderlich';
	}


  ngOnInit(): void {
		this.logoSrc = this.customerService.getLoadedLogo();
  }

  sendLink() {
    if (this.passwordForgetForm.invalid) {
      this.passwordForgetForm.markAllAsTouched();
      return;
    }

    const emailControl = this.passwordForgetForm.get('emailId');
    this.passwordReset.ebeMail = emailControl?.value || '';

    if (!this.passwordReset.ebeMail) {
      return;
    }

    if (this.environment.recaptchaActive) {
      this.recaptchaService.getToken('forgotPassword').subscribe({
        next: (token) => this.submitPasswordReset(token || ''),
        error: (err) => {
          console.error('Error fetching reCAPTCHA token', err);
          this.submitPasswordReset('');
        }
      });
    } else {
      this.submitPasswordReset('');
    }
  }

  private submitPasswordReset(token: string) {
    this.recaptchaCtrl.setValue(token);
    this.passwordReset.recaptchaResponse = token || '';
    this.authenicationService.forgotPassword(this.passwordReset).subscribe({
      next: (data) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
